import React, {useEffect, useState} from 'react';
import DynaTable from "../../MyTable/DynaTable";
import Button from "../../UI/Button";
import './ModalSelectProduct.scss';
import _axios from "../../../httpService";
import {toast} from "react-toastify";
import Loader from "../../Loader";
import {ReactTabulator} from "react-tabulator";
import TabulatorTableOptions from "../../../utils/TabulatorTableOptions";

const ModalSelectProduct = ({addHandler, closeModal, storeId}) => {

    const prefixUrl = localStorage.getItem("apiUrl");
    const [inventoryId, setInventoryId] = useState({});
    const [modalData, setModalData] = useState({});
    const [isLoad, setIsLoad] = useState(false);

    useEffect(() => {
        if (storeId !== "") {
            _axios.get(prefixUrl + "/cardex/?request=productList&storeId=" + storeId)
                .then((response) => {
                    if (response.data.status) {
                        setModalData(response.data.data)
                        setIsLoad(true)

                    } else {
                        toast.error(response.data.message)
                    }
                })
        }

    }, [])

    // const rowClickHandler = (data) => {
    //
    //     setInventoryId(data)
    // };
    function rowClickHandler(e, row) {
        // console.log(selectedRow.getData()["primaryKey"]);
        row.getTable().getSelectedRows().length === 0
            ? setInventoryId()
            : setInventoryId(row?._row.data);
    }

    return (

        <div className="main-modal-cordex">

            {isLoad ?
                <>
                    {Object.keys(modalData).length > 0 &&
                        <div className="table-side">
                            {/*<DynaTable*/}
                            {/*    column={modalData?.column}*/}
                            {/*    data={modalData?.data}*/}
                            {/*    className={"solid-table"}*/}
                            {/*    mainWidth={'100%'}*/}
                            {/*    onRowClick={(data) => setInventoryId(data)}*/}
                            {/*    searchFilterBox={modalData?.hasFilter}*/}
                            {/*    searchFilterBoxStyle={'solid-filter-box'}/>*/}
                            <ReactTabulator
                                columns={modalData?.column}
                                data={modalData?.data}
                                options={TabulatorTableOptions.style13}
                                events={{rowClick: rowClickHandler}}
                            />
                        </div>}

                    <div className={"text-center mt-4"}>
                        <Button color={'redBtn'} onClick={closeModal}> لغو </Button>
                        <Button color={'pBtn'} onClick={() => addHandler(inventoryId)}> انتخاب کالا </Button>
                    </div>
                </>

                : <Loader/>}


        </div>
    );
};

export default ModalSelectProduct;